import { Location } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { FileHandlerService } from 'src/app/services/file-handler.service';
import { HttpService } from 'src/app/services/http.service';
import { LoadingService } from 'src/app/services/loading.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-cantab-audio',
    templateUrl: './cantab-audio.component.html',
    styleUrls: ['./cantab-audio.component.scss']
})
export class CantabAudioComponent implements OnInit {

    constructor(
        private http: HttpService,
        private location: Location,
        public fileHandler: FileHandlerService,
        public loading: LoadingService,
        private el: ElementRef,
        private fb: FormBuilder,
        private toastr: ToastrService
    ) { }
    private apiPath = 'quiz-configs';
    @ViewChild('theForm') theForm: NgForm | undefined;
    formGroup = this.fb.group({});
    formChanged = false;
    voice: any = { view: '' };
    assetUrl = environment.assetUrl;
    currentAudio = null;

    submitForm(form: any): void {
        if (!form.valid) {
            this.el.nativeElement.querySelectorAll('[formcontrolname].ng-invalid')?.[0].focus();
            return;
        }

        let fdata = new FormData();
        if (form.value?.sound_active != undefined) {
            form.value.sound_active = Number(form.value.sound_active);
        }
        fdata.append('sound', this.voice.file);
        fdata.append('data', JSON.stringify(form.value));
        form.disable();
        this.http.PostFile(this.apiPath + '/update', fdata).then((r: any) => {
            form.enable();
            if (r.success) {
                this.toastr.success('Data saved successfully', 'Success');
                this.back();
            } else {
                if (r.response && r.response.wrong) {
                    Object.keys(r.response.wrong).forEach((key) => {
                        form.get(key)?.setErrors({ serverError: r.response.wrong[key][0] });
                        this.el.nativeElement.querySelectorAll('[formcontrolname="' + key + '"]')?.[0]?.focus();
                    });
                }
            }
        });
    }

    back(): void {
        this.location.back();
    }

    ngOnInit(): void {
        this.http.Get(this.apiPath, { filter: { name: 'CANTAB' } }).then((r: any) => {
            if (r.success && r?.response?.result?.data?.length) {
                const _data = r?.response?.result?.data[0];
                Object.keys(_data).forEach((key) => {
                    this.formGroup.addControl(key, new FormControl(_data[key]));
                });
                this.voice.view = _data.sound || '';
                this.currentAudio = _data.sound || null;
            } else {
                this.back();
            }
        });
    }

}
